<template>
  <!--
      作者 luoyiming
      时间：2020-08-30
      描述：设置-满额包邮
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">满额包邮设置</div>

      <el-form-item label="是否开启满额包邮">
        <div>
          <el-radio v-model="form.isOpen" label="1">开启</el-radio>
          <el-radio v-model="form.isOpen" label="0">关闭</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="单笔订单满" prop="money" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.money" type="number" style="width: 200px;"></el-input>
        元
        <div class="tips">
          如果开启满额包邮，设置0为全场包邮
        </div>
      </el-form-item>
      <el-form-item label="排除地区" prop="exclusionList">
        <div class="area-list">
          <span v-if="form.exclusionList.length === cityCount" class="color-red">全国</span>
          <span v-else v-for="(province, index) in showData" :key="index" class="pr16 color-red">
                  {{ province.name }}
                  <template v-if="!province.isAllCitys">
                    (
                    <span class="am-link-muted gray9">
                      <em v-for="(city, city_index) in province.citys" :key="city_index">
                        <span>{{ city.name }}</span>
                        <span v-if="city_index + 1 < province.citys.length">、</span>
                      </em>
                    </span>
                    )
                  </template>
                </span>
        </div>
        <el-button @click="addAreaClick" type="text" size="small">+点击添加(修改)排除满额包邮配送区域</el-button>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Areas v-if="show_area" :show_area="show_area" :areaModel="areaModel" :areas="options"
           @closeArea="closeAreaFunc"></Areas>
  </div>

</template>

<script>
import SettingApi from '@/api/setting.js'
import Areas from '../delivery/dialog/Area'

export default {
  components: {
    Areas: Areas
  },
  data () {
    return {
      form: {
        isOpen: '',
        money: '',
        exclusionList: []
      },
      loading: false,
      cityCount: -1,
      formData: [],
      /*区域数据源*/
      options: [],
      /*区域数据源*/
      optionsMap: {},
      /*区域选中的model*/
      areaModel: {
        index: 0
      },
      /*显示区域选中*/
      show_area: false,
      showData: []
    }
  },
  created () {
    this.getData()
  },

  methods: {
    getData () {
      let self = this
      SettingApi.fullfreeDetail({}, true)
        .then(res => {
          let vars = res.data
          self.form.isOpen = vars.isOpen
          self.form.money = vars.money
          let citys = res.data.formData ? res.data.formData.citys || [] : []
          for (var key in citys) {
            if (citys.hasOwnProperty(key)) {
              citys[key] = parseInt(citys[key])
            }
          }
          self.form.exclusionList = citys
          self.options = res.data.regionData
          self.options.forEach(function (area) {
            self.optionsMap[area.id] = area
            area.children.forEach(function (child) {
              self.$set(child, 'index', child.childIndex)
            })
          })
          self.cityCount = res.data.cityCount
          let province = res.data.formData ? res.data.formData.province || [] : []
          self.showData = self.getShowData({
            province: province,
            citys: self.form.exclusionList
          })
        })
        .catch(error => {
        })
    },
    getShowData: function (checkedData) {
      var self = this
      var formData = {}
      checkedData.province.forEach(function (provinceId) {
        var province = self.optionsMap[provinceId],
          citys = [],
          cityCount = 0
        for (var cityIndex in province.children) {
          if (province.children.hasOwnProperty(cityIndex)) {
            var cityItem = province.children[cityIndex]
            if (self.inArray(cityItem.id, checkedData.citys)) {
              citys.push({
                id: cityItem.id,
                name: cityItem.name
              })
            }
            cityCount++
          }
        }
        formData[province.id] = {
          id: province.id,
          name: province.name,
          citys: citys,
          isAllCitys: citys.length === cityCount
        }
      })
      return formData
    },
    addAreaClick () {
      this.areaModel.index = 0
      this.areaModel.type = 'edit'
      this.show_area = true
    },

    /*关闭区域选中弹窗*/
    closeAreaFunc (e) {
      let self = this
      this.show_area = e.statu
      if (e.type != 'confirm') {
        return
      }
      this.options = e.this_area

      let provinces = []
      let citys = []
      e.this_area.forEach(function (province, index) {
        if ((province.checked == true || province.indeterminate == true) && province.index.indexOf(self.areaModel.index) != -1) {
          provinces.push(province['id'])
          province.children.forEach(function (city) {
            if (city.checked == true && city.index == self.areaModel.index) {
              citys.push(city['id'])
            }
          })
        }
      })

      if (this.areaModel.type == 'edit') {
        this.showData = this.getShowData({
          province: provinces,
          citys: citys
        })
        //设置rule的region
        this.form.exclusionList = citys
      }
    },
    // 数组中是否存在指定的值
    inArray: function (val, array) {
      return array.indexOf(val) > -1
    },
    //提交表单
    onSubmit () {
      let self = this
      let params = Object.assign({}, this.form)
      params.exclusionList = this.form.exclusionList.join(',')
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          SettingApi.editFullfree(params, true)
            .then(res => {
              self.loading = false
              self.$message({
                message: '恭喜你，设置成功',
                type: 'success'
              })
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },
  }

}
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/fullfree/index.vue